import Api from '@/services/Api'
import GmwApi from '@/services/GmwApi'

export default {
    getall () {
        return Api().get('parties/getall')
    },


    //GMW
    getallgmw () {
        return GmwApi().get('parties/getall')
    },
}